export const sub = (currentPath, menuPath) =>
  currentPath.includes(menuPath) ? { active: true } : {};